import { DataTypeProvider } from "@devexpress/dx-react-grid"
import React, { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import TimeAgo from 'react-timeago'
import { Box, Chip } from "@mui/material"
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

import AuthService from "../services/auth-service"

// ************************************************************

const DateFormatter = ({ value }) => {
  if (value === "0000-00-00 00:00:00") return <></>
  return ( <b style={{ color: 'darkblue' }}><TimeAgo date={value} /></b> )
}
export const DateTypeProvider = props => <DataTypeProvider formatterComponent={DateFormatter} {...props} />

const RowNumFormatter = ({ row }) => { return <Chip label={row.row_num} size="small" variant="outlined" /> }
export const RowNumTypeProvider = props => <DataTypeProvider formatterComponent={RowNumFormatter} {...props} />

const SetupFormatter = ({ row, user }) => {
  var lvl = user.is_admin ? 2 : user.is_reseller ? 1 : 0
  var t = row.setup.split("\\").map((p, index) => {
    return (
      <React.Fragment key={index}>
        {p + " "}
        <br />
      </React.Fragment>
    )
  })
  if (lvl < 2) return (
    <Box sx={{ fontFamily: 'Monospace', fontSize: 14, m: 0, p: 0, display: 'flex', alignItems: 'center', gap: 1 }}>
      <a href={AuthService.ApiUrl() + "SoftwareTool/download/" + row.hash} rel="noreferrer" target="_blank">DOWNLOAD</a>
      {row.is_beta && <Chip label="BETA" color="warning" size="small" sx={{ fontSize: 10, height: 'auto', padding: '2px 4px' }} /> }
    </Box>
  )
  return (      
    <HtmlTooltip
      title={
        <React.Fragment>
          <Box sx={{ fontFamily: 'Monospace', fontSize: 12.5, m: 0, p: 0 }}>
            {t}
          </Box>
        </React.Fragment>
      } >
      <Box sx={{ fontFamily: 'Monospace', fontSize: 11, m: 0, p: 0 }}>
        <a href={AuthService.ApiUrl() + "SoftwareTool/download/" + row.hash} rel="noreferrer" target="_blank">{row.setup}</a>
      </Box>
    </HtmlTooltip>
  )
}
export const SetupTypeProvider = ({ user, ...props }) => (
  <DataTypeProvider 
    formatterComponent={(formatterProps) => <SetupFormatter {...formatterProps} user={user} />} 
    {...props} 
  />)

const IsBetaFormatter = ({ row, updateTableRows }) => {
  const [loading, setLoading] = useState(false)
  const handleClick = async () => {
    var msg = (row.is_beta) ? "Are you sure you want to COPY this software TO RELEASE?" : "Are you sure you want to DELETE this software FROM RELEASE?"
    if (window.confirm(msg)) {
      setLoading(true)
      try {
        if (row.is_beta) {
          var ret = await AuthService.copySoftwareToolToRelease(row.hash)
          console.log(ret)
        } else {
          var ret = await AuthService.deleteSoftwareToolFromRelease(row.hash)
          console.log(ret)
        }
        updateTableRows()
      } catch (error) {
        console.error("Error:", error)
      } finally {
        setLoading(false)
      }
    }
  }
  const tip_title = row.is_beta ? "Click to COPY TO RELEASE" : "Click to DELETE FROM RELEASE"
  const chip_color = loading ? "default" : row.is_beta ? "warning" : "success"
  const chip_variant = !loading ? "filled" : "outlined"
  const chip_clickable = !loading
  const chip_label = loading ? <CircularProgress size={24} /> : row.is_beta ? "1" : "0"
  return (
      <Tooltip 
        title={tip_title}
        PopperProps={{
          sx: {
            '& .MuiTooltip-tooltip': {
              backgroundColor: 'yellow',
              fontSize: '1.2em',
              color: 'black',
              whiteSpace: 'nowrap',
              display: 'inline-block',
            },
          },
        }}
      >
        <span>
        <Chip 
          label={chip_label}
          color={chip_color}
          variant={chip_variant}
          onClick={handleClick} 
          clickable={chip_clickable} 
        />
        </span>
      </Tooltip>
  )
}
export const IsBetaTypeProvider = props => <DataTypeProvider formatterComponent={(rowProps) => <IsBetaFormatter {...rowProps} updateTableRows={props.updateTableRows} />} {...props} />

const CounterFormatter = ({ value }) => {
  if (value) return (
    <b style={{ color: 'green' }}>    
      {value}
    </b>
  )
  return <>{value}</>
}
export const CounterTypeProvider = props => <DataTypeProvider formatterComponent={CounterFormatter} {...props} />

const HtmlTooltip = styled(({ className, ...props }) => ( <Tooltip {...props} classes={{ popper: className }} /> ))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 500,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}))
const HashFormatter = ({ row }) => {
  return (
    <>
    <HtmlTooltip
      title={
        <React.Fragment>
          {/* <Typography color="inherit">UNLOCKER</Typography> */}
          {/* <em>{"And here's"}</em> <b>{'some'}</b> <u>{'amazing content'}</u>.{' '} */}
          {/* {"It's very engaging. Right?"} */}
          {/* {row.file_hash} */}
          <Box sx={{ 
            whiteSpace: 'nowrap', 
            fontFamily: 'Monospace', 
            fontSize: 12.5, 
            m: 0, 
            p: 0,
          }}>
            {row.file_hash}
          </Box>
        </React.Fragment>
      }
    >
      <Box sx={{ fontFamily: 'Monospace', fontSize: 11, m: 0, p: 0 }}>
        {row.hash_type}
      </Box>
    </HtmlTooltip>
    </>
  )
}
export const HashTypeProvider = props => <DataTypeProvider formatterComponent={HashFormatter} {...props} />

// ************************************************************
// ************************************************************
// ************************************************************

// {
//   "id": 377,
//   "setup": "software_bu\\DI\\aeb_direct_inj__beta\\v4.0.0.95\\setup __ AEB Direct Injection __ CPP __ v4.0.0.95.exe",
//   "root": "software_bu",
//   "group": "DI",
//   "selector": "aeb_direct_inj",
//   "version": "4.0.0.95",
//   "is_beta": true,
//   "file_name": "setup __ AEB Direct Injection __ CPP __ v4.0.0.95.exe",
//   "file_hash": "a5dc1ded91e68fa6ac7fcc09810996c3c180be26cd88603d2c48bd7fd2f42974",
//   "hash_type": "sha256",
//   "name": "AEB Direct Injection",
//   "comp": "CPP",
//   "hash": "ade06188fd56a8499ec225e84882ed85b3e0eaa501c09c2810118cb2e30b776c",
//   "created_at": "2022-11-14 22:15:12"
// }

export default class SoftwareToolListTableProps {   
  constructor(props) { this.props = props }
  getTableColumns(user) {
    var lvl = user.is_admin  ? 2 : (user.is_reseller ? 1 : 0)
    var a = []
    if (lvl >= 0) a.push({ name: 'row_num',            title: '#',             getCellValue: row => row.row_num })
    if (lvl >= 2) a.push({ name: 'id',                 title: 'Id',            getCellValue: row => row.id })
    if (lvl >= 0) a.push({ name: 'created_at',         title: 'Created at',    getCellValue: row => row.created_at })
    if (lvl >= 2) a.push({ name: 'root',               title: 'Root',          getCellValue: row => row.root })
    if (lvl >= 2) a.push({ name: 'group',              title: 'Group',         getCellValue: row => row.group })
    if (lvl >= 0) a.push({ name: 'selector',           title: 'Selector',      getCellValue: row => row.selector })
    if (lvl >= 0) a.push({ name: 'name',               title: 'Name',          getCellValue: row => row.name })
    if (lvl >= 0) a.push({ name: 'comp',               title: 'Comp',          getCellValue: row => row.comp })
    if (lvl >= 0) a.push({ name: 'version',            title: 'Version',       getCellValue: row => row.version })
    if (lvl >= 2) a.push({ name: 'is_beta',            title: 'Beta',          getCellValue: row => row.is_beta })
    if (lvl >= 2) a.push({ name: 'hash',               title: 'Hash',          getCellValue: row => row.hash_type })
    if (lvl >= 0) a.push({ name: 'setup',              title: 'Setup',         getCellValue: row => row.setup })
    if (lvl >= 2) a.push({ name: 'counter',            title: 'Counter',       getCellValue: row => row.counter })
    if (lvl >= 2) a.push({ name: 'last_download',      title: 'Last download', getCellValue: row => row.last_download })
    return a
  }
  getTableColumnWidths(user) {
    if (user === null) {
      return [
        { columnName: 'row_num',        width: 100 },
        { columnName: 'id',             width: 0 },
        { columnName: 'created_at',     width: 120 },
        { columnName: 'root',           width: 0 },
        { columnName: 'group',          width: 100 },
        { columnName: 'selector',       width: 140 },
        { columnName: 'version',        width: 140 },
        { columnName: 'name',           width: 220 },
        { columnName: 'comp',           width: 80 },
        { columnName: 'is_beta',        width: 80 },
        { columnName: 'hash',           width: 0 },
        { columnName: 'setup',          width: 400 },
        { columnName: 'counter',        width: 0 },
        { columnName: 'last_download',  width: 0 },
      ]
    }
    var show_ext = false
    if (user !== null) 
      if (user.is_admin)
        show_ext = true
    
    //console.log("PROPS2", this.props)
    return [
      { columnName: 'row_num',        width: 100 },
      { columnName: 'id',             width: 0 },
      { columnName: 'created_at',     width: 120 },
      { columnName: 'root',           width: 0 },
      { columnName: 'group',          width: 100 },
      { columnName: 'selector',       width: 140 },
      { columnName: 'version',        width: 140 },
      { columnName: 'name',           width: 220 },
      { columnName: 'comp',           width: 80 },
      { columnName: 'is_beta',        width: 80 },
      { columnName: 'hash',           width: 0 },
      { columnName: 'setup',          width: 400 },
      { columnName: 'counter',        width: show_ext ? 100 : 0 },
      { columnName: 'last_download',  width: show_ext ? 150 : 0 },
    ]
  }  
  getTableColumnExtensions() {
    return [
      { columnName: 'row_num',            align: 'right' },
      { columnName: 'id',                 align: 'right' },
      { columnName: 'created_at',         align: 'right' },
      { columnName: 'version',            align: 'right' },
      { columnName: 'is_beta',            align: 'center' },
      { columnName: 'counter',            align: 'right' },
      { columnName: 'last_download',      align: 'right' },
    ]
  }
  getTableSortingStateColumnExtensions() {
    return [
      { columnName: 'row_num',            sortingEnabled: false },
      { columnName: 'hash',               sortingEnabled: false },
      { columnName: 'setup',              sortingEnabled: false },
    ]
  }
  getTableFilteringStateColumnExtensions() {
    return [
      { columnName: 'row_num',            filteringEnabled: false },
      { columnName: 'id',                 filteringEnabled: false },
      { columnName: 'created_at',         filteringEnabled: false },
      { columnName: 'hash',               filteringEnabled: false },
      { columnName: 'setup',              filteringEnabled: false },
      { columnName: 'last_download',      filteringEnabled: false },
    ]
  }
}
